import LogoAcat from '../../../assets/images/sponsors/acat.jpeg';
import UNAM from '../../../assets/images/sponsors/logo_unam.png';
import CICESE from '../../../assets/images/sponsors/logo_cicese.png';
import UABC from '../../../assets/images/sponsors/uabc.svg';
import CNYN from '../../../assets/images/sponsors/cnyn.jpeg';
import FIAD from '../../../assets/images/sponsors/fiad.svg';

export const Sponsors = () => {
  return (
    <>
      <section className="snn-page-section snn-topics">
        <h2 className="snn-title">Participating institutions</h2>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
            <img src={UNAM} alt="cic logo" />
          </div>
          <div>
            <img src={CNYN} alt="cic logo" />
          </div>
          <div>
            <img src={CICESE} alt="cic logo" />
          </div>
          <div>
            <img src={UABC} alt="cic logo" />
          </div>
        </div>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
            <img className="uabc-logo" src={FIAD} alt="FIAD logo"/>
          </div>
          <div>
            <img src={LogoAcat} alt="cic logo"/>
          </div>
          <div></div>
          <div></div>
        </div>
      </section>
    </>
  );
};
